import { Card, LinearProgress, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { CompanyRole, EnumCurrency, mapCurrencySimbol } from 'tdc-web-backend/enums/enums';
import useUserCompany from '../../../../utils/hooks/useUserCompany';
import { formatCurrency } from '../../../../utils/helpers';

type Props = {
  paid: number;
  unpaid: number;
  percentage: number;
  currency: EnumCurrency;
  backgroundColor?: string;
  progressColor?: string;
};

const PaymentLinearProgressCard = ({
  paid,
  unpaid,
  percentage,
  currency,
  backgroundColor,
  progressColor,
}: Props) => {
  const { userCompany } = useUserCompany();
  const userType = userCompany?.roles;
  const isUserBuyer = userType?.includes(CompanyRole.Buyer);

  return (
    <Card
      elevation={0}
      sx={{
        pt: 1,
        px: 3,
        pb: 1,
        borderRadius: '8px',
        width: '100%',
      }}
      className="react-joyride-step-3-payments"
    >
      <Stack direction="row" justifyContent="space-between" width="100%" sx={{ p: 1 }}>
        <Typography fontSize="1.2rem" fontWeight={600}>
          {isUserBuyer ? 'Paid' : 'Earned'} ({mapCurrencySimbol.get(currency)})
        </Typography>
        <Typography fontSize="1.2rem" fontWeight={600}>
          {isUserBuyer ? 'Remaining' : 'Expected'} ({mapCurrencySimbol.get(currency)})
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" width="100%">
        <Box sx={{ width: '100%' }}>
          <LinearProgress
            variant="determinate"
            value={percentage}
            sx={{
              height: '0.6rem',
              borderRadius: '16px',
              backgroundColor: backgroundColor || '#FFDAD4',
              '.MuiLinearProgress-barColorPrimary': {
                backgroundColor: progressColor || '#52AF66',
              },
            }}
          />
        </Box>
      </Stack>
      {/* TODO - How to handle this currency? */}
      <Stack direction="row" justifyContent="space-between" width="100%" sx={{ p: 1 }}>
        <Typography fontWeight={400}>{formatCurrency(paid, currency)}</Typography>
        <Typography fontWeight={400}>{formatCurrency(unpaid, currency)}</Typography>
      </Stack>
    </Card>
  );
};

export default PaymentLinearProgressCard;
